import { createAction } from 'typesafe-actions'

export * from './funnelOrder/actions'

export const init = createAction('INIT')()
